import { createFileRoute, redirect } from '@tanstack/react-router'

// Верхнеуровневого списка проектов нет: в проект проваливаются через компанию.
// Роут сохранён как мягкий редирект для старых закладок на /projects.
export const Route = createFileRoute('/_app/projects/')({
  beforeLoad: () => {
    throw redirect({ to: '/companies' })
  },
})
